import { render, staticRenderFns } from "./fl44-unknown-volume-form-row-proposal-specification-table.vue?vue&type=template&id=9bd38616&scoped=true&"
import script from "./fl44-unknown-volume-form-row-proposal-specification-table.vue?vue&type=script&lang=js&"
export * from "./fl44-unknown-volume-form-row-proposal-specification-table.vue?vue&type=script&lang=js&"
import style0 from "./fl44-unknown-volume-form-row-proposal-specification-table.vue?vue&type=style&index=0&id=9bd38616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd38616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bd38616')) {
      api.createRecord('9bd38616', component.options)
    } else {
      api.reload('9bd38616', component.options)
    }
    module.hot.accept("./fl44-unknown-volume-form-row-proposal-specification-table.vue?vue&type=template&id=9bd38616&scoped=true&", function () {
      api.rerender('9bd38616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-form-row-proposal-specification-table.vue"
export default component.exports